<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <dropzone v-if="verDropZone" :url="URL_BASE()+ 'fotos/create/'+codeQR" @cargarFotos="getFotos" />
            </div>
            <div v-show="!procesando" class="col-lg-12">
                <div v-if="fotos.length>=1">
                    <div class="alert alert-info">
                        <h5> <i class="fa fa-info fa-lg"></i> Imágenes Subidas</h5>
                        Puede eliminar las que no crea conveniente.
                    </div>
                    <div class="row" style="border: 2px solid #e5e5e5;border-radius:15px;background-color:#f0f3f5">

                        <div class="col-lg-3" v-for="foto in fotos" :key="foto.Id">
                            <img v-b-tooltip.hover class="img-fluid img-thumbnail" style="max-height: 300px;z-index: 1;"
                                :src="URL_WEB()+foto.foto" :alt="foto.descripcion" :title="foto.descripcion">
                            <button @click="fotoModificar={...foto}" v-b-modal.modalDialogEditarFotoDescripcion
                                type="button" style="z-index: 2;" title="Editar descripción"
                                class="btn btn-info btn-sm float-right">
                                <i class="fa fa-edit"></i> </button> &nbsp;
                            <button type="button" style="z-index: 2;" title="Eliminar Fotografía"
                                @click="deleteFoto(foto.Id)" class="btn btn-danger btn-sm float-right">
                                <i class="fa fa-trash"></i> </button> &nbsp;

                        </div>
                    </div>
                </div>
            </div>
            <b-modal ref="modalDialogEditarFotoDescripcion" size="lg" id="modalDialogEditarFotoDescripcion"
                cancel-variant="default" title="Editar Descripción: ">
                <div class="row">
                    <div class="col-xl-4 col-lg-4">

                        <div class="form-group mt-5">
                            <br>

                            <textarea class="form-control" v-model="fotoModificar.descripcion" rows="4"></textarea>

                        </div>
                    </div>
                    <div class="col-xl-8 col-lg-8">
                        <div class="form-group">
                            <img class="img-fluid img-thumbnail" style="max-height: 300px;z-index: 1;"
                                :src="URL_WEB()+fotoModificar.foto" title="Foto seleccionada">
                        </div>
                    </div>

                </div>

                <template #modal-footer>
                    <b-button variant="secondary" size="sm" class="float-right"
                        @click="$bvModal.hide('modalDialogEditarFotoDescripcion');">
                        <i class="fa fa-times"></i> Cancelar
                    </b-button>
                    <b-button variant="indigo" size="sm" class="float-right"
                        @click="$bvModal.hide('modalDialogEditarFotoDescripcion');updateDescripcionFoto()">
                        <i class="fa fa-times"></i> Actualizar
                    </b-button>
                </template>
            </b-modal>
        </div>
        <procesando v-show="procesando" :tipo="1" :texto="texto_proceso" />
    </div>
</template>
<script>
    import dropzone from '../compartidos/DropZone.vue'
    import procesando from '../compartidos/Procesando.vue'
    import axios from 'axios'
    export default {
        name: "Paso2Component",
        components: {
            dropzone,
            procesando
        },
        props: ["codeQR"],
      
        data() {
            return {
                verDropZone:false,
                procesando: false,
                texto_proceso: 'Espere la carga de fotos..',
                max_foto: 0,
                fotos: [],
                fotoModificar: {
                    Id: "",
                    descripcion: "",
                    foto: ""
                }
            }
        },
        methods: {
            getFotos() {
                 const self = this;
                this.procesando = true;
                axios.post(this.URL_BASE() + 'fotos/read/' + this.codeQR).then((respuesta) => {
                    setTimeout(() => {
                this.verDropZone=true;
            }, 500);
                   
                   this.fotos = [];
                    this.fotos = respuesta.data.data;
                    this.max_foto = respuesta.data.data.length;
                    if(this.max_foto){
                        this.activarPaso3();
                    }
                    this.reiniciarTextoProceso();
                }).catch(function (error) {
                    this.mostrarErrorFatal(error);
                    this.reiniciarTextoProceso();
                });
            },
            deleteFoto(idFoto) {
                this.$swal({
                    title: '¿Estás seguro?',
                    text: '¡Esta foto se eliminará!',
                    type: 'warning',
                    showCancelButton: true,
                    buttonsStyling: false,
                    confirmButtonText: 'Confirmar',
                    cancelButtonText: 'Cancelar',
                    confirmButtonClass: 'btn m-r-5 btn-warning',
                    cancelButtonClass: 'btn btn-default',
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.value) {
                        this.texto_proceso = 'Eliminando foto seleccionada..';
                        this.procesando = true;
                        axios.delete(this.URL_BASE() + "fotos/delete/" + idFoto + '/' + this.codeQR).then(
                            respuesta => {
                                if (respuesta.data.msg == 'exito') {
                                    this.$swal('Proceso completado', '', 'success')
                                    this.fotos = [];
                                    this.fotos = respuesta.data.dataAdicional == "" ? [] : respuesta.data
                                        .dataAdicional;
                                    this.max_foto = this.fotos.length;
                                }
                                this.reiniciarTextoProceso();
                            }).catch(function (error) {
                            console.log("er store" + error);
                        });
                        return true;
                    } else if (result.dismiss) {
                        return false;
                    }
                })
            },
            updateDescripcionFoto() {
                this.texto_proceso = 'Actualizando descripción de foto seleccionada..';
                this.procesando = true;
                axios.put(this.URL_BASE() + 'fotos/update/' + this.codeQR, this.fotoModificar, {
                    /* headers: {
                       Authenticate: this.API_KEY()
                     }*/
                }).then((respuesta) => {
                    if (respuesta.data.msg == 'exito') {
                        this.$swal('Proceso completado', '', 'success')
                        this.fotos = [];
                        this.fotos = respuesta.data.dataAdicional;
                        this.max_foto = this.fotos.length;

                    }
                    this.reiniciarTextoProceso();

                }).catch(function (error) {
                    this.mostrarErrorFatal(error);
                    this.reiniciarTextoProceso();
                });
            },
            reiniciarTextoProceso() {
                this.procesando = false
                this.texto_proceso = 'Espere la carga de fotos..';
            },
            activarPaso3(){
                this.$emit('max_fotos','activar');
                
            }

        },
        created() {
            if (this.codeQR != '') {
                this.getFotos();
            }
        },
        watch: {
            codeQR(newQuestion, oldQuestion) {
               // this.codeQR = newQuestion;
                this.getFotos();
            }
        }

    }
</script>